import { MVTLayer } from '@deck.gl/geo-layers'
import { FeatureType } from 'stores/features'

export default class AggregationLayer extends MVTLayer {
  public readonly type = FeatureType.Aggregation
}
